import type {PageRouteConfig} from '@router';

import CpcList from 'modules/Cpc/List/CpcList';
import {routes} from 'routes/routes';

export function createCpcListRoute(): PageRouteConfig {
  return {
    element: <CpcList />,
    layout: {
      title: 'کلیک های خریداری شده',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.PROMOTION_CENTER
    }
  };
}
